import { createGlobalStyle, css } from 'styled-components'

// ${css usado para o vscode indentar

const GlobalStyles = createGlobalStyle`
${({ theme }) => css`
  :root {
    --headerColor: ${theme.colors.header};
    --primary: ${theme.colors.primary};
    --primaryLighten50: ${theme.colors.primaryLighten50};
    --primaryLighten60: ${theme.colors.primaryLighten60};
    --secondary: ${theme.colors.secondary};

    --info: ${theme.colors.info};
    --success: ${theme.colors.success};
    --successAlert: ${theme.colors.successAlert};
    --warning: ${theme.colors.warning};
    --danger: ${theme.colors.danger};

    --hover: ${theme.colors.hover};
    --inative: ${theme.colors.inative};
    --loading: #ffb450;

    --white: ${theme.colors.white};
    --light: ${theme.colors.light};
    --tertiary: ${theme.colors.tertiary};
    --gray: ${theme.colors.gray};
    --stormGray: ${theme.colors.stormGray};
    --dark: ${theme.colors.dark};

    --mainHeaderHeight: 48px;
    --heightChatHeader: 57px;
    --heightChatSubmitBar: calc(80px + 2rem);

    --neutralHighPure: ${theme.colors.neutral.high.pure};
    --neutralHighLightest: ${theme.colors.neutral.high.lightest};
    --neutralHighLight: ${theme.colors.neutral.high.light};
    --neutralHighMedium: ${theme.colors.neutral.high.medium};
    --neutralHighDark: ${theme.colors.neutral.high.dark};

    --neutralLowLightest: ${theme.colors.neutral.low.lightest};
    --neutralLowLight: ${theme.colors.neutral.low.light};
    --neutralLowMedium: ${theme.colors.neutral.low.medium};
    --neutralLowDark: ${theme.colors.neutral.low.dark};
    --neutralLowPure: ${theme.colors.neutral.low.pure};

    --font-size-tiny: ${theme.font.sizes.tiny};
    --font-size-2xsm: ${theme.font.sizes.xxsmall};
    --font-size-xsm: ${theme.font.sizes.xsmall};
    --font-size-sm: ${theme.font.sizes.small};
    --font-size-md: ${theme.font.sizes.medium};
    --font-size-lg: ${theme.font.sizes.large};
    --font-size-xlg: ${theme.font.sizes.xlarge};
    --font-size-2xlg: ${theme.font.sizes.xxlarge};
    --font-size-huge: ${theme.font.sizes.xxxlarge};
    --backgroundColor: #fff;

    --theme-font-family: ${theme.font.family};

    --bulletWrapperSize: 1.25rem;
  }

  /* Shoreline feedback must stay above the ReactModal overlay (9999). */
  [data-sl-toast-stack] {
    z-index: 10000;
  }

  .fill {
    &__primary {
      fill: var(--primary);
    }

    &__dark {
      fill: var(--dark);
    }

    &__secondary {
      fill: var(--secondary);
    }
  }

  /* Fake Lib  */

  .color,
  .text {
    &-primary {
      color: var(--primary);
    }

    &-gray,
    &__gray {
      color: var(--gray);
    }
  }
`}
`

export default GlobalStyles
